module.exports = __webpack_public_path__ + "img/collection-weddingRingsBestseller@2x.c3f3425.jpg";